<template>
  <div class="adm-config">
    <div class="adm-config-header">
      <div>
        <h2 class="adm-config-title">
          <feather-icon icon="SettingsIcon" size="22" class="mr-75" />
          Configurações
        </h2>
        <p class="adm-config-sub">Gerencie scripts, integrações, e-mail e infraestrutura da plataforma</p>
      </div>
    </div>

    <div class="adm-config-tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        class="adm-config-tab"
        :class="{ 'adm-config-tab--active': activeTab === tab.key }"
        @click="activeTab = tab.key"
      >
        <feather-icon :icon="tab.icon" size="14" class="mr-50" />
        {{ tab.label }}
      </button>
    </div>

    <div class="adm-config-content">
      <AwsConfig v-if="activeTab === 'aws'" />
      <ScriptConfig v-if="activeTab === 'scripts'" />
      <TagManager v-if="activeTab === 'tagmanager'" />
      <EmailConfig v-if="activeTab === 'email'" />
      <Webhooks v-if="activeTab === 'webhooks'" />
      <ChatSuporte v-if="activeTab === 'suporte'" />
    </div>
  </div>
</template>

<script>
import AwsConfig from './AwsConfig/Index.vue'
import ScriptConfig from './ScriptConfig/Index.vue'
import TagManager from './TagManager/Index.vue'
import EmailConfig from './EmailConfig/Index.vue'
import Webhooks from './Webhooks/Index.vue'
import ChatSuporte from '../Configuracoes/ChatSuporte.vue'

export default {
  name: 'AdminConfiguracoes',
  components: { AwsConfig, ScriptConfig, TagManager, EmailConfig, Webhooks, ChatSuporte },
  data() {
    return {
      activeTab: this.$route.query.tab || 'scripts',
      tabs: [
        { key: 'scripts', label: 'Scripts do Site', icon: 'CodeIcon' },
        { key: 'tagmanager', label: 'Tag Manager', icon: 'TagIcon' },
        { key: 'email', label: 'E-mail', icon: 'MailIcon' },
        { key: 'webhooks', label: 'Webhooks', icon: 'LinkIcon' },
        { key: 'aws', label: 'AWS S3', icon: 'DatabaseIcon' },
        { key: 'suporte', label: 'Chat de Suporte', icon: 'MessageCircleIcon' },
      ],
    }
  },
  watch: {
    activeTab(val) {
      if (this.$route.query.tab !== val) {
        this.$router.replace({ query: { ...this.$route.query, tab: val } }).catch(() => {})
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$orange: #E86A10;
$border: rgba(255,255,255,.08);
$bg: transparent;

.adm-config { padding: 0; }

.adm-config-header {
  margin-bottom: 24px;
}
.adm-config-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
  color: var(--dk-text-primary, #0f172a);
  margin: 0 0 4px;
}
.adm-config-sub {
  font-size: 13.5px;
  color: var(--dk-text-muted, #64748b);
  margin: 0;
}

.adm-config-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  border-bottom: 2px solid $border;
  padding-bottom: 0;
}
.adm-config-tab {
  display: inline-flex;
  align-items: center;
  padding: 10px 18px;
  border: none;
  background: none;
  color: var(--dk-text-muted, #64748b);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border-bottom: 2.5px solid transparent;
  margin-bottom: -2px;
  transition: all .18s;
  border-radius: 0;

  &:hover { color: $orange; }
  &--active {
    color: $orange;
    border-bottom-color: $orange;
  }
}

.adm-config-content {
  min-height: 400px;
}
</style>
